import { IconCamera as TablerIconCamera } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconCamera = /*#__PURE__*/ createOutlineIcon(TablerIconCamera, 'IconCamera');
